<template>
  <span>
    <b-nav-text right>
      <i
        class="hamburger fa fa-bars"
        aria-hidden="true"
        @click.prevent="$store.dispatch('toggleMenuDrawer')"
      />
    </b-nav-text>

    <vue-offcanvas
      v-model="canvas"
      :width="300"
      :duration="0.2"
      align="right"
      effect="ease-in-out"
      close-on-external-click
      close-on-esc
    >
      <div class="side-menu p-4">
        <ul class="menulist">
          <feature name="log" tag="span">
            <li v-if="isLoggedIn && user.canUseLog">
              <b-link @click="goToLog">
                <b class="menuitemlisttitle text-muted">
                  {{ $t('NAVIGATION_item_log') }}
                </b>
              </b-link>
            </li>
          </feature>

          <li v-if="isLoggedIn">
            <b-link @click="goToProfile">
              <b class="menuitemlisttitle text-muted">
                {{ $t('NAVIGATION_item_profile') }}
              </b>
            </b-link>
            <ul class="menuitemlist">
              <li>
                <b-link @click="goToProfile(0)">{{ $t('overview') }}</b-link>
              </li>
              <li>
                <b-link @click="goToProfile(1)">{{ $t('user') }}</b-link>
              </li>
              <li>
                <b-link @click="goToProfile(2)">BASFI</b-link>
              </li>
            </ul>
          </li>
          <li v-if="isLoggedIn">
            <b-link @click="goToFavs">
              <b class="menuitemlisttitle text-muted">
                {{ $t('NAVIGATION_item_my_favs') }}
              </b>
            </b-link>
          </li>
          <li>
            <b class="menuitemlisttitle">{{ $t('language') }}</b>
            <ul class="menuitemlist text-muted">
              <li
                v-for="(lang, key) in availableLanguages"
                v-bind:key="key"
                href="#"
                class="text-uppercase"
                @click="$store.dispatch('setLanguage', lang)"
              >
                <b-link>
                  <u v-if="language === lang">{{ lang }}</u>
                  <span v-else>{{ lang }}</span>
                </b-link>
              </li>
            </ul>
          </li>
          <li v-if="isLoggedIn">
            <b-link @click="logout">
              <b class="menuitemlisttitle text-muted">
                {{ $t('NAVIGATION_item_logout') }}
              </b>
            </b-link>
          </li>
          <li v-else>
            <b-link @click="login">
              <b class="menuitemlisttitle text-muted">{{ $t('login') }}</b>
            </b-link>
          </li>

          <feature name="physio" tag="span">
            <template v-if="isPhysio">
              <li>
                <b-button @click="goToPhysio" variant="physio">
                  {{ $t('NAVIGATION_item_physio') }}
                </b-button>
              </li>
            </template>
          </feature>
        </ul>
      </div>
    </vue-offcanvas>
  </span>
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';
import VueOffcanvas from '../SideMenu';

import Loader from '@/components/Loader';
import config from '@/config';

export default {
  name: 'navigation',
  components: { Loader, VueOffcanvas },
  data() {
    return { availableLanguages: config.availableLanguages };
  },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['user', 'isLoggedIn', 'isMenuDrawerOpen', 'isPhysio']),
    canvas: {
      get() {
        return this.isMenuDrawerOpen;
      },
      set(value) {
        this.$store.dispatch('setMenuDrawer', value);
      },
    },
  },
  methods: {
    goToProfile(tabIndex = null) {
      if (tabIndex === null) {
        this.$router.push({ name: 'profile' });
      } else {
        this.$router.push({ name: 'profile_index', params: { tabIndex } });
      }
      this.$store.dispatch('setMenuDrawer', false);
    },
    goToPhysio() {
      this.$router.push({ name: 'physio' });
      this.$store.dispatch('setMenuDrawer', false);
    },
    login() {
      this.$store.dispatch('setMenuDrawer', false);
      this.$store.dispatch('openLoginModal');
    },
    goToFavs() {
      this.$router.push({ name: 'home' });
      this.$store.dispatch('resetFilter');
      this.$store.dispatch('setFilter', { favorites: true });
      this.$store.commit('setIsFilterOpen', false);
      this.$store.dispatch('setMenuDrawer', false);
    },
    goToLog() {
      const { protocol, host } = window.location;
      const domain = host.split('.').slice(-2).join('.');
      window.location.href = [('rheumafit.ch', 'rheumafit.dev')].includes(
        domain
      )
        ? `${protocol}//log.${domain}`
        : 'http://localhost:3000';
    },
    logout() {
      this.$store.dispatch('logout');
      this.$store.dispatch('setMenuDrawer', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import '/../../theme';

.hamburger {
  padding-left: 2rem;
  font-size: 18px;

  &:hover {
    color: black;
  }
}

.side-menu {
  min-height: 100vh;
  border-left: 4px solid theme-color('light');
}

.profileLink {
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  position: relative;
  top: 5px;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  @media screen and (max-width: 500px) {
    max-width: 120px;
  }

  @media screen and (max-width: 400px) {
    max-width: 70px;
  }
}

.menulist {
  list-style: none;
  margin: 0;
  padding: 0;

  > li {
    padding: 10px;
    &:after {
      content: '';
      background: rgba(200, 200, 200, 0.5);
      display: block;
      height: 1px;
      width: 85%;
      margin: 30px auto 10px;
    }
  }
}

.menuitemlist {
  list-style: none;
  margin: 10px 0 0 0;
  padding: 0 0 0 20px;
}

.menuitemlisttitle {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/elements/LoginIndicator/mobile.vue